export enum EOrgaoCodigo {
    DPU = 1,
    PF = 2,
    ReceitaFederal = 3,
    Funtrab = 4,
    Sas = 5,
    Cedami = 6,
    CentralMatriculas = 7,
    Cras = 8,
    Funsat = 9  
}
export enum EOrgaoDescricao {
    DPU = "DPU",
    PF = "Policia Federal",
    ReceitaFederal = "Receita federal",
    Funtrab = "FUNTRAB",
    Sas = "SAS",
    Cedami = "CEDAMI",
    CentralMatriculas = "CENTRAL DE MATRICULAS",
    Cras = "CRAS",
    Funsat = "FUNSAT"

}
       
                                      				 
	                 				 
	                 				 
